export default __webpack_public_path__ + "static/media/level-9.6006326f.png";